const validateLoginForm = (email, password) => {
  const errors = {};

  // Email validation
  if (!email) {
    errors.email = "Email is required";
  } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
    errors.email = "Invalid email format";
  }

  // Password validation
  if (!password) {
    errors.password = "Password is required";
  }

  return errors;
};

export default validateLoginForm;
